(function () {
    'use strict';
    app.controller('subscriptionReportController', ['$scope', '$cookies', 'progressBarService', '$rootScope', 'subscriptionReportService', '$location', function ($scope, $cookies, progressBarService, $rootScope, subscriptionReportService, $location) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined || getLocalValue('userRole') != 'SAdmin') {
            $location.path('/login');
            return;
        }

        var hideMessage = function () {
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.message = ''
        }

        $scope.reloadDatePicker = function () {
            $('.daterangepickerInp').daterangepicker({
                singleDatePicker: true,
                showDropdowns: true,
                locale: {
                    format: 'MM-DD-YYYY'
                }
            });
        }
        $scope.reloadDatePicker();
        $scope.reset = function () {
            $scope.IshideAccordion = true;
            $scope.email = "";
            $scope.transactionNumber = "";
            $scope.startDate = moment().subtract(29, 'days').format('MM-DD-YYYY');
            $scope.endDate = moment().format('MM-DD-YYYY');

            $scope.searchResult = [];
        }
        $scope.IshideAccordion = true;
        $scope.pagination = {
            currentPage: 1,
            itemsPerPage: 10,
            totalRows: 0,
            sortBy: '',
            reverse: false
        }

        $scope.reset();

        $scope.getData = function (click) {
            if (!$scope.isError) {
                progressBarService.showProgressBar();
                if (click == "search") {
                    $scope.pagination.currentPage = 1;
                    $scope.pagination.sortBy = '';
                    $scope.pagination.reverse = false;
                }

                $scope.IshideAccordion = false;
                var startDate = Format_YYYYMMDD($scope.startDate.split('-'));
                var endDate = Format_YYYYMMDD($scope.endDate.split('-'));

                var parameter = {
                    eSpectraOrderStartDate: startDate,
                    eSpectraOrderEndDate: endDate,
                    eSpectraPageNo: $scope.pagination.currentPage,
                    eSpectraSortBy: $scope.pagination.sortBy,
                    eSpectraSortDirection: $scope.pagination.reverse ? 'desc' : 'asc',
                    eSpectraEmail: $scope.email,
                    eSpectraCCRequestID: $scope.transactionNumber
                }

                subscriptionReportService.getSubscriptionReport(parameter).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        $scope.message = response.data.message;
                        $scope.isError = true;
                        $scope.isSuccess = false;
                        //$timeout(hideMessage, 10000);
                    }
                    else {
                        $scope.searchResult = response.data;
                        if (response.data.length > 0) {
                            $scope.pagination.totalRows = response.data[0].eSpectraTotalRows;
                        }
                    }

                    progressBarService.hideProgressBar();
                });
            } else {
                $scope.IshideAccordion = true;
                $scope.searchResult = '';
            }
        }

        if ($rootScope.eSpectraUserTransactionsEmailID != undefined) {
            $scope.email = $rootScope.eSpectraUserTransactionsEmailID;
            $scope.getData();
        }

        $scope.setPage = function (currentPage) {
            $scope.pagination.currentPage = currentPage;
            $scope.getData();
        }
        $scope.sort = function (sortBy) {
            if ($scope.searchResult.length > 0) {
                $scope.pagination.sortBy = sortBy;
                $scope.pagination.currentPage = 1;
                $scope.pagination.reverse = !$scope.pagination.reverse;
                $scope.getData();
            }
        }

        $scope.exportReportData = function () {

            progressBarService.showProgressBar();
            var today, dd, mm, yyyy, currentDate, startDate, endDate, parameter;
            today = new Date();
            dd = today.getDate();
            mm = today.getMonth() + 1; //January is 0!

            yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            currentDate = mm + '/' + dd + '/' + yyyy;
            startDate = Format_YYYYMMDD($scope.startDate.split('-'));
            endDate = Format_YYYYMMDD($scope.endDate.split('-'));
            parameter = {
                eSpectraOrderStartDate: startDate,
                eSpectraOrderEndDate: endDate,
                eSpectraEmail: $scope.email,
                eSpectraCCRequestID: $scope.transactionNumber,
                eSpectraSortBy: $scope.pagination.sortBy,
                eSpectraSortDirection: $scope.pagination.reverse ? 'desc' : 'asc'
            }
            subscriptionReportService.exportSubscriptionReport(parameter).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                else {
                    var csv = convertArrayOfObjectsToCSV({
                        data: response.data
                    }, $scope.startDate, $scope.endDate);

                    BlobDownloadCSV('E-commerce Transaction Report_' + currentDate + '.csv', csv)

                }

                progressBarService.hideProgressBar();
            });
        }


        function convertArrayOfObjectsToCSV(args,startDate,endDate) {

            var result, ctr, keys, columnDelimiter, lineDelimiter, data, headers;

            data = args.data || null;
            if (data == null || !data.length) {
                return null;
            }

            columnDelimiter = args.columnDelimiter || ',';
            lineDelimiter = args.lineDelimiter || '\n';


            keys = Object.keys(data[0]).slice(1);

            headers = ["Customer Name",
                "Customer Email",
                "Date",
                "Product Details",
                "Product Duration",
                "Amount Collected($)",
                "Discount Code",
                "Credit Card No",
                "CC Reference ID",
                "Request ID",
                "Subscription Start Date",
                "Subscription Expiry Date"]

            result = 'Report Name' + columnDelimiter + "E-commerce Transaction Report" + lineDelimiter;
            result += 'Transaction Range - Start Date' + columnDelimiter + startDate + lineDelimiter;
            result += 'Transaction Range - End Date' + columnDelimiter + endDate + lineDelimiter + lineDelimiter;
            result += headers.join(columnDelimiter);
            result += lineDelimiter;

            data.forEach(function (item) {

                ctr = 0;
                keys.forEach(function (key) {
                    if (ctr > 0) result += columnDelimiter;

                    result += item[key];
                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }

        $scope.onKeyPress = function (event, data) {
            if (event.keyCode == 13) {
                $scope.getData(data);
                event.preventDefault();
            }
        };

        $scope.compareTransactionDates = function (transactionStartDate, transactionEndDate) {
            var startDate = new Date(transactionStartDate);
            var endDate = new Date(transactionEndDate);
            if (startDate > endDate) {
                $scope.isError = true;
                $scope.message = 'Transaction Range - End Date can not be less than Transaction Range - Start Date.'
            } else {

                $scope.isError = false;
            }
        }
    }]);
})();